export default __webpack_public_path__ + "static/media/ward.039cc15a.jpg";